import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import DropdownTreeSelect from 'react-dropdown-tree-select';

// Tree select component for selecting groups and locations
function DomainSelect({ field, showInactive }) {
  const [availableDomains, setAvailableDomains] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    let groups = [];
    let locations = [];

    const hasInactiveDomainsSelected = field.value?.some((item) =>
      item.className.includes('inactive')
    );

    // If the user has selected an inactive domain and the show inactive checkbox is unchecked,
    // we need to trigger the onChange event to remove the inactive domains from the selected list.
    // This will make sure those domains are not included in the POST request to the server and
    // it will trigger the form validation if the user has selected only inactive domains.
    if (hasInactiveDomainsSelected && !showInactive) {
      const filteredDomains = field.value.filter((item) => !item.className.includes('inactive'));
      field.onChange(filteredDomains);
    }

    field.value?.forEach((item) => {
      if (item.className.includes('filter-group')) {
        groups.push(item.value);
      } else if (item.className.includes('filter-location')) {
        locations.push(item.value);
      }
    });

    fetch('/reports/users_groups_and_locations', {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ locations, groups, show_inactive: showInactive ? '1' : '0' }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAvailableDomains(data);
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      });
  }, [showInactive]);

  // Need to wrap in useMemo or every time a checkbox is changed,
  // the dropdown rerenders and loses it's internal state.
  const dropdownTreeSelect = useMemo(() => {
    return (
      <DropdownTreeSelect
        {...field}
        data={availableDomains}
        texts={{ placeholder: 'Search groups and locations' }}
        onChange={(_currNode, selectedNodes) => field.onChange(selectedNodes)}
        showDropdown='always'
        showPartiallySelected
        keepTreeOnSearch
        keepChildrenOnSearch
      />
    );
  }, [availableDomains]);

  if (error) {
    return <div className='alert alert-danger'>Failed to fetch groups and locations</div>;
  } else {
    return <>{dropdownTreeSelect}</>;
  }
}

DomainSelect.propTypes = {
  field: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  showInactive: PropTypes.bool.isRequired,
};

export default DomainSelect;
